import {getAccessTokenOrThrow} from "../../shared/services/auth.service";
import {DefaultUserSettings, UpdateUserSettingsDto, UserSettingsDto} from "./dtos/settings.dto";

export async function getUserSettings(): Promise<UserSettingsDto> {
  const token = await getAccessTokenOrThrow();
  return await fetch(
    `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/user-settings`,
    {headers: {Authorization: `Bearer ${token}`}})
    .then(async response => {
      if (!response.ok) {
        throw new Error(`Failed to fetch user settings: ${response.statusText}`);
      }
      // 204 for someone who has never saved a setting (SettingsController.GetUserSettings
      // returns Ok(null)), the same as the apps' own GET: `response.json()` on an empty
      // body would otherwise throw and read as a load failure.
      if (response.status === 204) {
        return DefaultUserSettings;
      }
      return await response.json() as UserSettingsDto
    });
}

export async function updateUserSettings(settings: UpdateUserSettingsDto): Promise<UserSettingsDto> {
  const token = await getAccessTokenOrThrow();
  return await fetch(
    `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/user-settings`,
    {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(settings)
    })
    .then(async response => {
      if (!response.ok) {
        throw new Error(`Failed to update user settings integrations: ${response.statusText}`);
      }
      return await response.json() as UserSettingsDto
    });
}